export function getItem(storage) {
  return function execute(key) {
    return storage.getItem(key);
  };
}

export default getItem(window.localStorage);
